<template>
  <div id="app">
    <header-element></header-element>
    <router-view />
  </div>
</template>

<script>
import HeaderElement from './components/Header'

export default {
  name: 'app-header',
  data () {
    return {
      brand: 'Marketing Tools' 
    }
  },
  components: {  
    HeaderElement
  }
}
</script>

<style lang="scss">
  #app {
    font-family: $ts-font-roboto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $ts-color-black;
  }

  body {
    font-size: 1.1rem;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  h1 {
    margin: 0;
    font-weight: 300;
  }

  h2,
  h3,
  h4,
  h5 {
    font-weight: 300;
  }

  .btn {
    border: 2px solid transparent;
  }

  .btn,
  .btn-lg {
    border-radius: 2rem;
  }

  .btn-primary {
    background-color: $ts-color-red;
    border-color: $ts-color-red;
  }

  .btn-primary:hover {
    background-color: $ts-color-red-2;
    border-color: $ts-color-red-2;
  }

  .btn-outline-primary {
    color: $ts-color-red;
    border-color: $ts-color-red;
  }

  .btn-outline-primary:hover {
    color: $ts-color-white;
    border-color: $ts-color-red-2;
    background-color: $ts-color-red-2;
  }

  .btn-outline-secondary {
    color: $ts-color-dark-grey;
    border-color: $ts-color-dark-grey;
  }

  .btn-outline-secondary:hover {
    color: $ts-color-white;
    border-color: $ts-color-dark-grey;
    background-color: $ts-color-dark-grey;
  }

   .container-fluid--bg-red {
    text-align: center;
    background: rgb(152,27,30);
    background: linear-gradient(90deg, rgba(152,27,30,1) 0%, rgba(216,37,50,1) 47%, rgba(255,146,54,1) 100%);
    padding-top: 75px;
    color: $ts-color-white;
    margin: 0 0 175px;
    padding: 12% 20px;
  }

  // slanted edges here
  .edge--bottom {
    @include angle(after);
  }

  .container {
    padding: 25px;
    min-height: 500px;
    margin-bottom: 50px;
  }

  .container-fluid--bg-red  {
    a {
      color: $ts-color-orange !important; 
      text-decoration: underline;
    }

    p {
      font-size: 18px;
      font-weight: 300;
    }
  }  

  .container--bg-white {
    background: $ts-color-white;
  }

  .container--bg-transparent {
    background: transparent;
  }

  .container--negative-top-margin {
    margin-top: -250px;
    position: relative;
    z-index: 99;

    @media (max-width: 575.98px) {
      margin-top: -225px;
    }
  }

  .container--box-shadow {
    -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
  }

  .container--border-radisu-small {
    border-radius: 10px;
  }
</style>
